import { Flex } from "@mantine/core";
import {
  IconLetterE,
  IconLetterN,
  IconLetterS,
  IconLetterW,
} from "@tabler/icons-react";
import { useCallback } from "react";

import { useInputProps } from "../hooks/useInputProps";
import IconCheckboxGroup from "../IconCheckboxGroup/IconCheckboxGroup";
import Coordinates from "./Coordinates";

interface ICoordinates {
  isLatitude: boolean;
  isLongitude: boolean;
  value: string | { nums: string; dir: string };
  id: string;
  twoDigit?: boolean;
  exclusive?: string;
  required?: boolean;
}

const OilCoordinates = (props: ICoordinates) => {
  const baseName =
    props.exclusive && props.exclusive.trim() !== ""
      ? `${props.id}-exclusive-${props.exclusive}`
      : props.id;
  const coordId = baseName + ".nums";
  const dirId = baseName + ".dir";
  const defDir = typeof props.value === "string" ? "" : props.value?.dir;
  const dirProps = useInputProps(
    dirId,
    defDir,
    props.required,
    dirId.includes("-exclusive-") ? true : props.exclusive,
  );

  const getDefVal = useCallback(() => {
    let value = "";
    if (props.value) {
      if (typeof props.value === "string") value = props.value;
      else if (typeof props.value === "object") value = props.value?.nums;
    }

    if (!(!isNaN(parseFloat(value)) && isFinite(parseFloat(value)))) value = "";

    return value;
  }, [props.value]);

  const directionOptions = props.isLatitude
    ? [
        { value: "N", icon: IconLetterN },
        { value: "S", icon: IconLetterS },
      ]
    : [
        { value: "E", icon: IconLetterE },
        { value: "W", icon: IconLetterW },
      ];

  const hasDirectionError =
    !["N", "E", "S", "W"].includes(dirProps.value) && dirProps.error;

  return (
    <Flex align="center" gap="sm">
      <Coordinates
        {...props}
        id={coordId}
        value={getDefVal()}
        required={props.required}
        isLat3={props?.twoDigit === true}
      />
      <IconCheckboxGroup
        value={dirProps.value}
        onChange={dirProps.onChange}
        options={directionOptions}
        error={hasDirectionError}
      />
    </Flex>
  );
};

export default OilCoordinates;
